import React from "react"
import PropTypes from "prop-types"

const FormFieldset = ({ children = [] }) => <fieldset className="mb-5">{children}</fieldset>

FormFieldset.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}

export default FormFieldset
